import "./Banner.scss";
import BannerImg from "../../../assets/banner-img.png"
import { useNavigate, Link } from "react-router-dom";
import { BsInstagram } from "react-icons/bs";
const Banner = () => {
    const navigate = useNavigate();
    return (
        <div className="hero-banner">
            <div className="content">
            <div className="text-content">
                <h1>SALES</h1>
                <p>Lorem ipsum dolor sit amet consectetur,
                 adipisicing elit. Impedit sed voluptatem
                 distinctio totam molestiae quis explicabo a!</p>
                 <div className="ctas">
                    <div onClick={() => navigate("/salecategories")} className="banner-cta">Sale Products</div>
                    
                    
                    <Link to="https://www.instagram.com/myracasual/"><div className="banner-cta v2">Shop Now on <BsInstagram /></div></Link>
                 </div>
                 </div>
                 <img src={BannerImg} className="banner-Img" alt="" />
            </div>
                
                
           
           
            
        </div>
    );
};

export default Banner;
